import { useHits } from 'react-instantsearch-core';

import type {
  EyewearHit,
  StoreHit,
  StrapHit,
  WatchHit,
} from '@/integrations/algolia/types';

export const DummyHits = () => {
  const { hits } = useHits<WatchHit | StrapHit | StoreHit | EyewearHit>();
  return <>{hits?.map((hit) => hit.objectID)}</>;
};
